var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#EFFAF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29C15.0293 29 11 24.9707 11 20C11 15.0293 15.0293 11 20 11C24.9707 11 29 15.0293 29 20C29 24.9707 24.9707 29 20 29ZM19.1 22.7V24.5H20.9V22.7H19.1ZM20.9 21.2195C21.6233 21.0015 22.2442 20.531 22.6497 19.8936C23.0552 19.2562 23.2183 18.4943 23.1093 17.7468C23.0002 16.9993 22.6263 16.3158 22.0556 15.8208C21.4849 15.3258 20.7554 15.0523 20 15.05C19.2718 15.0499 18.566 15.3021 18.0027 15.7637C17.4394 16.2252 17.0534 16.8677 16.9103 17.5817L18.6761 17.9354C18.7262 17.6847 18.8465 17.4534 19.0229 17.2683C19.1994 17.0833 19.4247 16.9522 19.6728 16.8902C19.9208 16.8283 20.1814 16.838 20.4241 16.9184C20.6668 16.9987 20.8817 17.1463 21.0438 17.344C21.206 17.5417 21.3086 17.7814 21.3398 18.0352C21.371 18.2889 21.3295 18.5463 21.2202 18.7774C21.1108 19.0085 20.9381 19.2038 20.7221 19.3406C20.5061 19.4774 20.2557 19.55 20 19.55C19.7613 19.55 19.5324 19.6448 19.3636 19.8136C19.1948 19.9824 19.1 20.2113 19.1 20.45V21.8H20.9V21.2195Z",
    fill: "#38C793"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon (1).f098107794f37fca2f2bb4454ef5c203.svg";
export { ForwardRef as ReactComponent };